import { Component, Inject, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { CampaignsService } from 'src/app/services/campaigns.service';
import { MainService } from 'src/app/services/main.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-distribution-totals',
  templateUrl: './distribution-totals.component.html',
  styleUrls: ['./distribution-totals.component.scss']
})
export class DistributionTotalsComponent implements OnInit, AfterViewInit {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  displayedColumns: string[] = ['id', 'nombre', 'cantidad', 'folio', 'estatus_folio'];
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();

  // Variables para la barra de progreso
  confirmedCount: number = 0;
  totalCount: number = 0;
  progressPercent: number = 0;

  constructor(
    public dialogRef: MatDialogRef<DistributionTotalsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { campaign: any },
    private campaignService: CampaignsService,
    private main: MainService
  ) {}

  ngOnInit(): void {
    this.loadMaterialsTotales();
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    this.dataSource.sortingDataAccessor = (item: any, property: string) => {
      switch (property) {
        case 'nombre':
          return item.nombre?.toLowerCase() || '';
        case 'cantidad':
          return Number(item.cantidad) || 0;
        case 'folio':
          return item.folio?.toLowerCase() || '';
        case 'estatus_folio':
          return this.getStatusBuhoName(item.status_buho).toLowerCase();
        default:
          return item[property];
      }
    };

    this.dataSource.filterPredicate = (record: any, filter: string): boolean => {
      const nombre = (record.nombre || '').toLowerCase();
      const cantidad = String(record.cantidad ?? '').toLowerCase();
      const folio = String(record.folio || '').toLowerCase();
      const estatus = this.getStatusBuhoName(record.status_buho).toLowerCase();

      return nombre.includes(filter) || cantidad.includes(filter) || folio.includes(filter) || estatus.includes(filter);
    };
  }

  loadMaterialsTotales(): void {
    if (!this.data?.campaign?.id) return;

    this.main.ShowLoading();
    this.campaignService.getMaterialsTotales(this.data.campaign.id).subscribe({
      next: (res: any) => {
        this.main.HideLoading();
        const rawData = Array.isArray(res) ? res[0] : (res?.data?.[0] || res?.data || []);
        this.dataSource.data = rawData;
        this.calculateProgress(rawData);
      },
      error: (err: any) => {
        this.main.HideLoading();
        console.error('Error al cargar totales:', err);
        Swal.fire('Error', 'Ocurrió un error al obtener los totales de materiales.', 'error');
      }
    });
  }

  calculateProgress(data: any[]): void {
    this.totalCount = data.length;
    // status_buho === 4 corresponde a "Confirmado"
    this.confirmedCount = data.filter((item: any) => +item.status_buho === 4).length;
    this.progressPercent = this.totalCount > 0 ? (this.confirmedCount * 100) / this.totalCount : 0;
  }

  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value || '';
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  downloadExcel(): void {
    if (this.dataSource.data.length === 0) return;

    this.main.ShowLoading();
    setTimeout(() => {
      const dataToPrint = this.dataSource.filteredData.map((row: any) => ({
        'Nombre operativo': row.nombre || 'Sin nombre',
        'Cantidad': row.cantidad ?? 0,
        'Folio': row.folio || '-',
        'Estatus folio': this.getStatusBuhoName(row.status_buho)
      }));

      const campaignName = this.data?.campaign?.name ? `_${this.data.campaign.name}` : '';
      const fileName = `Totales_Distribucion${campaignName}`;

      this.main.generateExcel(dataToPrint, fileName, 'Totales');
      this.main.HideLoading();
    }, 40);
  }

  getStatusBuhoName(status: number | string | null | undefined): string {
    if (status === null || status === undefined || status === '') return '-';
    switch (+status) {
      case 1: return 'Re-enviado';
      case 2: return 'Revisar';
      case 3: return 'Pendiente';
      case 4: return 'Confirmado';
      default: return '-';
    }
  }

  getBadgeClass(status: number | string | null | undefined): string {
    switch (+status!) {
      case 1: return 'bg-info';
      case 2: return 'bg-warning text-dark';
      case 3: return 'bg-secondary';
      case 4: return 'bg-success';
      default: return 'bg-secondary';
    }
  }
}